import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit, Input } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { ItemCoverageType, ItemType } from '../../../shared/models/item.type.interface';
import { RValue } from '../../../shared/models/r.value.interface';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ItemFilter } from '../../models/item.filter';
import { IdiItemSource } from '../../../shared/models/idiitem.source.interface';
import { BulkUpdateComponent } from '../../item/bulk-update/bulk-update.component';
import { ItemSourceEditComponent } from '../item-source-edit/item-source-edit.component';
import { BulkUpdateData } from '../../item/models/bulk-update.interface';
import { ItemUpdateTarget_Enum } from '../../enums/item-update-target.enum';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { IDIItemSourceList } from '../../models/idiItemSourceList.interface';
import { FileService } from '../../../shared/services/file.service';
import { ImportItemSourceComponent } from '../../item/import-item-source/import-item-source.component';
import { Dealer } from '../../../shared/models/dealer.interface';
import { PushItems } from '../../../shared/models/pushItems.interface';
import { bufferTime } from 'rxjs';

export interface ItemDialogData {
  id: any;
  itemTypes: ItemType[];
  rValues: RValue[];
}

@Component({
  selector: 'app-item-source-list',
  templateUrl: './item-source-list.component.html',
  styleUrls: ['./item-source-list.component.scss']
})
export class ItemSourceListComponent implements OnInit {

  dataSource = new MatTableDataSource<IDIItemSourceList>();
  displayedColumns: string[] =
    ['item_Name', 'rValue_Desc', 'itemType_Desc', 'item_Part', 'external_Item_Part', 'action'];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  items: IDIItemSourceList[];
  itemTypes: ItemType[];
  rValues: RValue[];
  itemFilter: ItemFilter = new ItemFilter();
  showBulkUpdate: boolean = false;
  showItemPush: boolean = false;
  showItemTypePush: boolean = false;

  isRequesting: boolean = false;
  showPushProcessingMsg: boolean = false;
  processingStageMessage: string = '';

  dealerIds: number[] = [];
  dealerChunks: number[][] = [];
  itemChunks: number[][] = [];

  chunksToProcess: number = 0;
  groupsProcessed: number = 0;
  rowsModified: number = 0;
  groupsErrored: number = 0;


  isIDIItemSource: boolean = false;

  constructor(private adminService: AdminService, private fileService: FileService, public dialog: MatDialog) { }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.initializeSearchCriteria();

    this.adminService.getItemTypes(null)
      .subscribe({
        next: (data) => {
          this.itemTypes = data;
        }
      });

    this.adminService.getrValues()
      .subscribe({
        next: (data) => {
          this.rValues = data;
        }
      });

    this.getDealerIdChunks();
  }

  initializeSearchCriteria() {
    this.itemFilter.itemTypeId = null;
    this.itemFilter.rValueId = null;
    this.itemFilter.searchText = null;
    this.itemFilter.statusId = 1;
    this.filterItems();
  }

  onItemTypeChange(itemTypeId: number) {
    this.showBulkUpdate = false;
    this.showItemPush = false;
    this.showItemTypePush = false;
    this.showPushProcessingMsg = false;
    this.groupsErrored = 0;
    this.groupsProcessed = 0;
    this.rowsModified = 0;
}

  filterItems() {
    this.showPushProcessingMsg = false;
    this.showItemTypePush = false;

    this.adminService.searchIDIItemSourceList(this.itemFilter)
      .subscribe({
        next: (data) => {
          this.items = data;

          this.dataSource.data = this.items;
          this.showItemPush = this.itemFilter.itemTypeId !== null; // && this.itemFilter.itemTypeId === this.itemTypes.find(it => it.itemCoverageType_ID === ItemCoverageType.AeroBarrier).itemType_ID;
          this.showBulkUpdate = (this.itemFilter.itemTypeId !== null || this.itemFilter.rValueId !== null || this.itemFilter.searchText !== null) && !this.showItemPush;          
        }
      });
  }


  exportItems() {
    let dealerId = this.adminService.getDealerId();
    this.isRequesting = true;
    this.adminService.exportItemSourceList(this.itemFilter, dealerId)
      .subscribe({
        next: (data) => {
          this.isRequesting = false;
          this.fileService.downloadFile(data, 'SourceItemList.csv');
        },
        error: (error: string) => this.onError(error)
      });
  }

  showEdit(itemId) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = { id: itemId, itemTypes: this.itemTypes, rValues: this.rValues } as ItemDialogData;
    dialogConfig.width = '1100px';

    const itemDialogRef = this.dialog.open(ItemSourceEditComponent, dialogConfig);

    itemDialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      this.filterItems();
    });
  }

  bulkUpdate() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = { items: this.items, itemUpdateTarget: ItemUpdateTarget_Enum.IDIItemSource } as BulkUpdateData;
    dialogConfig.width = '700px';

    const bulkUpdateDialogRef = this.dialog.open(BulkUpdateComponent, dialogConfig);

    bulkUpdateDialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      this.filterItems();
    });
  }

  pushItems() {
    this.itemFilter.itemTypeId;
    this.processingStageMessage = 'Verifying Dealer Item Type';
    this.showItemTypePush = true;
    this.showPushProcessingMsg = false;
    this.groupsErrored = 0;
    this.groupsProcessed = 0;
    this.rowsModified = 0;
    this.isRequesting = true;

    this.adminService.pushIDIItemsTypeToDealers(this.itemFilter.itemTypeId)
      .subscribe({
        next: (data) => {
          console.log(data === null);
        },
        complete: () => {
          this.showItemTypePush = false;
          this.pushItemsToDealers();
        },
        error: (err) => {
          this.onError(err);
          this.isRequesting = false;
          this.showItemTypePush = false;
        }
      });
  }

  pushItemsToDealers() {    
    let selectedItems = [];
    this.items.forEach((value) => {
      selectedItems.push(value.item_ID);
    });

    this.processingStageMessage = 'Pushing Items To Dealers';

    this.isRequesting = true;
    this.showPushProcessingMsg = true;
    this.groupsErrored = 0;
    this.groupsProcessed = 0;
    this.rowsModified = 0;

    this.itemChunks = this.chunkArray(selectedItems, 25);
    this.chunksToProcess = this.itemChunks.length * this.dealerChunks.length;

    // initiate the first call to process items
    this.pushChunk();
  }

  pushChunk() {
    let ic = this.itemChunks[this.groupsProcessed];
    let pushRequest: PushItems = { dealerIds: this.dealerIds, itemIds: ic }
    console.log(`processing items  ${ic.toString()}`);
    this.pushItemsSynchronously(pushRequest);
  }

  async pushItemsSynchronously(pushRequest: PushItems ) {
    await this.adminService.pushIDIItemsToDealers(pushRequest)
      .subscribe({
        next: (data) => {
          this.groupsProcessed++;
          if (this.groupsProcessed !== this.chunksToProcess) {
            this.pushChunk();
          }
          this.rowsModified = this.rowsModified + data;
          console.log('items added or updated: ' + this.rowsModified);
        },
        complete: () => {
          this.isRequesting = (this.groupsProcessed === this.chunksToProcess ? false : true);
        },
        error: (err) => {
          this.onError(err);
          this.groupsProcessed++;
          this.groupsErrored++;
          if (this.groupsProcessed !== this.chunksToProcess) {
            this.pushChunk();
          }
          this.isRequesting = (this.groupsProcessed === this.chunksToProcess ? false : true);
        }
      });
  }

  getDealerIdChunks() {
    this.adminService.getDealers()
      .subscribe({
        next: (data) => {
          data.filter(d => d.dealer_ID != null).forEach(dr => {
            this.dealerIds.push(dr.dealer_ID);
          });

          this.dealerIds = this.dealerIds.sort((a, b) => { return a - b });
          this.dealerChunks = this.chunkArray(this.dealerIds, this.dealerIds.length );  
        },
        complete: () => {}
  });
  }

  chunkArray<T>(array: T[], chunkSize: number): T[][] {
  const result: T[][] = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    const chunk = array.slice(i, i + chunkSize);
    result.push(chunk);
  }
  return result;
}

  hideProcessingMsg() {
    this.showPushProcessingMsg = false;
  }

  toggleStatus(page: string, id) {
    let dealerId = this.adminService.getDealerId();

    this.adminService.toggleStatus(page, id, dealerId)
      .subscribe(result => {
        console.log(result);
        if (result.id > 0) {
          this.items.find(al => al.item_ID == id).item_isActive = result.isActive;
          let activeStatusId = page + "_status_active" + id;
          let inActiveStatusId = page + "_status_inactive" + id;

          if (result.isActive) {
            document.getElementById(activeStatusId).className = "text-success";
            document.getElementById(inActiveStatusId).className = "";
          }
          else {
            document.getElementById(activeStatusId).className = "";
            document.getElementById(inActiveStatusId).className = "text-danger";
          }
        }
      });
  }

  onError(response: string) {

    window.alert($localize`Sorry, something went wrong.  Please contact Bidit Support.` + 'r\n' + response);
    console.log(response);
  }

  itemImport() {

    let dialogData = {

    } as ImportItemSourceComponent;

    const dialogRef = this.dialog.open(ImportItemSourceComponent, {
      width: '75%',
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(result => {
      this.filterItems();
      console.log('The dialog was closed');
    });
  }
}
